module.exports = __webpack_public_path__ + "img/170.6edda2b6.jpg";